import { render, staticRenderFns } from "./SortIndicator.vue?vue&type=template&id=1c993e91&scoped=true&"
import script from "./SortIndicator.vue?vue&type=script&lang=ts&"
export * from "./SortIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SortIndicator.vue?vue&type=style&index=0&id=1c993e91&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c993e91",
  null
  
)

export default component.exports